import React from 'react';

import { Button } from '@material-ui/core';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import NotifyTruckingCompanyContainer from '../notifyTruckingCompany/NotifyTruckingCompanyContainer';
import CommonOrderHeader from '../../common/orders/CommonOrdersIncognitoHeader';
import CommonOrderDateTimeDock from '../../common/orders/CommonOrderDateTimeDock';
import CommonOrderTopTextFields from '../../common/orders/CommonOrderTopTextFields';
import CommonOrderTableTrc from '../../common/trucker/CommonOrderTableTrc';
import CommonOrderDriverTextField from '../../common/trucker/ComonOrderDriverTextField';
import CommonOrderAdditionalInformation from '../../common/orders/CommonOrderAdditionalInformation';
import OrderButtonsContainer from '../../common/orders/ordersButtons/OrderButtonsContainer';

import PickupOrder from '../../../models/PickupOrder';
import { UserRoleType } from '../../../models/User';

import style from '../../common/orders/ordersStyle.module.css';
import commonStyles from '../../common/common.module.css';

const styles = (theme: Theme) =>

  createStyles({
    button: {
      width: '110px',
      marginTop: '86px'
    }
  });


interface trkPickupOrderProps {
  classes: any;
  pickupOrder: PickupOrder;
  secretKey: string;
  handleChange: (fieldName: string, event: any) => void;
  handleSave: any;
  handleSelectPickUpTime: () => void;
};

const trkPickupOrder = (props: trkPickupOrderProps) => {

  const { pickupOrder, secretKey } = props;
  const forwarder : { org: string, orgAddress: string } = {
    org: pickupOrder.forwarder_company_name,
    orgAddress: pickupOrder.forwarder_company_info && pickupOrder.forwarder_company_info.address? pickupOrder.forwarder_company_info.address : '--'
  }

  return (
    
    <div className={ style.trkOrderContainer }>

      <CommonOrderHeader
        number={ pickupOrder.number }
        forwarder={ forwarder }
        type={ 'po' }
      />

      <div className={ style.horizontalLine }></div>

      <CommonOrderDateTimeDock
        pickupOrder={ props.pickupOrder }
        handleSelectPickUpTime={ props.handleSelectPickUpTime }
        pickupDate={ props.pickupOrder.pickup_date }
        pickupDateChange={ ()=> {}}
        cutoffDate={ props.pickupOrder.cutoff_date }
        cutoffTime={ props.pickupOrder.cutoff_time }
        userRole={ UserRoleType.INCOGNITO }
        changeInputCutOffTime={ ()=>{} }
        type='po'
      /> 

      <div className={  [style.wrapper, style.additionalInfo].join(' ') }>
        <div className={ `${ commonStyles.header }` }>Additional info (Remarks from forwarder)</div>
        <div className={ style.pod }>{ pickupOrder.additional_info ? pickupOrder.additional_info : 'Not assigned' }</div>
      </div>

      <div className={ `${ commonStyles.wrapper } ${ style.wrapper }` }>
        <h3 className={ `${ commonStyles.header }` }>Additional information</h3>
        <CommonOrderTopTextFields
          pickupOrder={ pickupOrder }
          handleFieldsInput={() => {} }
          type={ 'po' }
          userRole={ UserRoleType.INCOGNITO }
        />
      </div>

      <div className={ `${ commonStyles.wrapper } ${ style.wrapper }` }>
        <h3 className={ `${ commonStyles.header }` }>Orders</h3>
        <CommonOrderTableTrc 
          pickupOrder={ props.pickupOrder } 
        />
      </div>

      <div className={ `${ commonStyles.wrapper } ${ style.wrapper }` }>
        <h3 className={ `${ commonStyles.header }` }>Trucking Information</h3>
        <div className={ style.driverNameAndBtnWrapper }>
        <CommonOrderDriverTextField
          pickupOrder={ pickupOrder }
          handleChange={props.handleChange }
        />
        <div className={ style.btnContainerDrvWrapper }>
        <Button className={ props.classes.button } onClick={ props.handleSave } color="primary" variant="contained" >Update</Button>

        </div>
        </div>
        <div className= { `${ style.notifyTruckingCompanyContainer } ${ style.notifyTruckingCompanyContainerIncogn }`}>

        <NotifyTruckingCompanyContainer pickupOrder={ pickupOrder } notifyWho={ "driver" } secretKey={ secretKey }/>
        <div className={ style.orderBtnContainerWrapper }>
          <OrderButtonsContainer 
            order={ props.pickupOrder }
            secretKey={ props.secretKey } 
          />
        </div>
        </div>
      </div>
      
      <div className={ `${ commonStyles.wrapper } ${ style.wrapper }` }>
        <h3 className={ `${ commonStyles.header }` }>Additional Information</h3>
        <CommonOrderAdditionalInformation 
          pickupOrder={ pickupOrder }
          handleFieldsInput={ props.handleChange }
          type={ 'trc' }
        />
      </div>

    </div>
  );
}

export default withStyles(styles)(trkPickupOrder);